import { handleActions } from 'redux-actions';
import * as getFieldsActions from '../actions/getFieldsActions';

let getFieldsState = {
  advertisingsTypes: null,
  appliancesTypes: null,
  brandsTypes: null,
  modelsTypes: null,
  modelsTypesByBrands: null,
  vehicleTypes: null,
  categoriesTypes: null,
  colorsTypes: null,
  conditionersTypes: null,
  driveTypes: null,
  engineTypes: null,
  entertainmentsTypes: null,
  facilitiesTypes: null,
  functionsTypes: null,
  interiorsTypes: null,
  seatMaterialsTypes: null,
  tachographsTypes: null,
  tintsTypes: null,
  transfersTypes: null,
  parkingTypes: null,
  steeringArrangementTypes: null,
  driveUnitTypes: null,
};
export const fields = handleActions(
  {
    [getFieldsActions.getParkingTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getParkingTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        parkingTypes: payload.data,
      });
    },
    [getFieldsActions.getParkingTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Request Types Error', payload.data.message);
      return (state = {
        ...state,
        parkingTypes: payload.data.message,
      });
    },
    [getFieldsActions.getModelsByBrand]: (state, action) => {
      return state;
    },
    [getFieldsActions.getModelsByBrandSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        modelsTypesByBrands: payload.data,
      });
    },
    [getFieldsActions.getModelsByBrandError]: (state, action) => {
      let { payload } = action;
      console.log('Request Types Error', payload.data.message);
      return (state = {
        ...state,
        modelsTypesByBrands: payload.data.message,
      });
    },
    [getFieldsActions.getModelsByBrandsKeys]: (state, action) => {
      return state;
    },
    [getFieldsActions.getModelsByBrandsKeysSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        modelsTypesByBrands: payload.data,
      });
    },
    [getFieldsActions.getModelsByBrandsKeysError]: (state, action) => {
      let { payload } = action;
      console.log('Request Types Error', payload.data.message);
      return (state = {
        ...state,
        modelsTypesByBrands: payload.data.message,
      });
    },
    [getFieldsActions.getModelsTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getModelsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        modelsTypes: payload.data,
      });
    },
    [getFieldsActions.getModelsTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Request Types Error', payload.data.message);
      return (state = {
        ...state,
        modelsTypes: payload.data.message,
      });
    },
    [getFieldsActions.getAdvertisingsTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getAdvertisingsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        advertisingsTypes: payload.data,
      });
    },
    [getFieldsActions.getAdvertisingsTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Request Types Error', payload.data.message);
      return (state = {
        ...state,
        advertisingsTypes: payload.data.message,
      });
    },
    [getFieldsActions.getAppliancesTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getAppliancesTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        appliancesTypes: payload.data,
      });
    },
    [getFieldsActions.getAppliancesTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Maintenance Levels', payload.data.message);
      return (state = {
        ...state,
        appliancesTypes: payload.data.message,
      });
    },
    [getFieldsActions.getBrandsTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getBrandsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        brandsTypes: payload.data,
      });
    },
    [getFieldsActions.getBrandsTypesError]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        brandsTypes: payload.data.message,
      });
    },
    [getFieldsActions.getCategoriesTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getCategoriesTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        categoriesTypes: payload.data,
      });
    },
    [getFieldsActions.getCategoriesTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        categoriesTypes: payload.data.message,
      });
    },
    [getFieldsActions.getVehicleTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getVehicleTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        vehicleTypes: payload.data,
      });
    },
    [getFieldsActions.getVehicleTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Vehicle Types', payload.data.message);
      return (state = {
        ...state,
        vehicleTypes: payload.data.message,
      });
    },
    [getFieldsActions.getColorsTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getColorsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        colorsTypes: payload.data,
      });
    },
    [getFieldsActions.getColorsTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        colorsTypes: payload.data.message,
      });
    },
    [getFieldsActions.getConditionersTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getConditionersTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        conditionersTypes: payload.data,
      });
    },
    [getFieldsActions.getConditionersTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        conditionersTypes: payload.data.message,
      });
    },
    [getFieldsActions.getDriveTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getDriveTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        driveTypes: payload.data,
      });
    },
    [getFieldsActions.getDriveTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        driveTypes: payload.data.message,
      });
    },
    [getFieldsActions.getEngineTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getEngineTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        engineTypes: payload.data,
      });
    },
    [getFieldsActions.getEngineTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Request Types Error', payload.data.message);
      return (state = {
        ...state,
        engineTypes: payload.data.message,
      });
    },
    [getFieldsActions.getEntertainmentsTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getEntertainmentsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        entertainmentsTypes: payload.data,
      });
    },
    [getFieldsActions.getEntertainmentsTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Maintenance Levels', payload.data.message);
      return (state = {
        ...state,
        entertainmentsTypes: payload.data.message,
      });
    },
    [getFieldsActions.getFacilitiesTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getFacilitiesTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        facilitiesTypes: payload.data,
      });
    },
    [getFieldsActions.getFacilitiesTypesError]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        facilitiesTypes: payload.data.message,
      });
    },
    [getFieldsActions.getFunctionsTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getFunctionsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        functionsTypes: payload.data,
      });
    },
    [getFieldsActions.getFunctionsTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        functionsTypes: payload.data.message,
      });
    },
    [getFieldsActions.getInteriorsTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getInteriorsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        interiorsTypes: payload.data,
      });
    },
    [getFieldsActions.getInteriorsTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        interiorsTypes: payload.data.message,
      });
    },
    [getFieldsActions.getSeatMaterialsTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getSeatMaterialsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        seatMaterialsTypes: payload.data,
      });
    },
    [getFieldsActions.getSeatMaterialsTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        seatMaterialsTypes: payload.data.message,
      });
    },
    [getFieldsActions.getTachographsTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getTachographsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        tachographsTypes: payload.data,
      });
    },
    [getFieldsActions.getTachographsTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        tachographsTypes: payload.data.message,
      });
    },
    [getFieldsActions.getTintsTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getTintsTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        tintsTypes: payload.data,
      });
    },
    [getFieldsActions.getTintsTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        tintsTypes: payload.data.message,
      });
    },
    [getFieldsActions.getTransfersTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getTransfersTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        transfersTypes: payload.data,
      });
    },
    [getFieldsActions.getTransfersTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        transfersTypes: payload.data.message,
      });
    },
    [getFieldsActions.getSteeringArrangementTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getSteeringArrangementTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        steeringArrangementTypes: payload.data,
      });
    },
    [getFieldsActions.getSteeringArrangementTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        steeringArrangementTypes: payload.data.message,
      });
    },
    [getFieldsActions.getDriveUnitTypes]: (state, action) => {
      return state;
    },
    [getFieldsActions.getDriveUnitTypesSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        driveUnitTypes: payload.data,
      });
    },
    [getFieldsActions.getDriveUnitTypesError]: (state, action) => {
      let { payload } = action;
      console.log('Service Types', payload.data.message);
      return (state = {
        ...state,
        driveUnitTypes: payload.data.message,
      });
    },
  },
  getFieldsState
);
